import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import createTea from '@/components/createTea';
import successTea from '@/components/successTea';
import RevelationPage from '@/components/revelationModule/revelationPage';
import loginPage from '@/components/loginPage';
import mainPage from '@/components/mainPage'
import changeData from '@/components/parentsModule/changeData'
import mailPage from '@/components/mailPage'
import sideMenu from '@/components/parentsModule/sideMenu';
import ListaPresentes from '@/components/parentsModule/ListaPresentes';
import checklistGestante from '@/components/parentsModule/checklistGestante';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    components: {main: Home}, 
    children: [
      {
        path: '/login',
        name: 'login',
        components: {homePage: loginPage}
      },      
      {
        path: '/parentsMenu',
        name: 'parentsMenu',
        components: {homePage: sideMenu},
        children: [
          {
            path: '/changeData',
            name: 'changeData',
            components: {home: changeData}            
          },
          {
            path: '/ListaPresentes',
            name: 'ListaPresentes',
            components: {home: ListaPresentes}            
          },
          {
            path: '/checklistGestante',
            name: 'checklistGestante',
            components: {home: checklistGestante}            
          }           
        ]
      },
      {
        path: '/',
        name: 'mainPage',
        components: {homePage: mainPage},
        children: [
          {
            path: '/',
            name: 'createTea',
            components: {second: createTea},
          },
          {
            path: '/success/:pathURL',
            name: 'successTea',
            components: {second: successTea}
          }          
        ]
      },      
    ]
  },
  {
    path: '/access/:pathURL',
    name: 'revelationPage',
    components: {main: RevelationPage}
  },
  {
    path: '/mail',
    name: 'mailPage',
    components: {main: mailPage}    
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   console.log("Router", to, from)
//   next()
//   // if (to.name !== 'Login' && ((localStorage.loggedIn == 'false') || (typeof localStorage.loggedIn == 'undefined'))) next({ name: 'Login' })
//   // else next()
// });

export default router
